import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

import BackArrow from "../../atoms/backArrow/backArrow";
import rightArrow from "../../assets/images/right_caret.svg";
import FloatingInput from "../../atoms/floatingInput/floatingInput";
import { makeAPICall } from "../../services/apiService";
import "./applyCoupon.scss";
import GenericModal from "src/GenericModal";
import Coupon from "../../assets/newPurchase/coupon.svg";
import GreenTick from "../../assets/newPurchase/greenTick.svg";
import CrossIcon from "../../assets/fieldIcons/crossIcon.svg";
import WarnRed from "../../assets/images/warn-circle-red.svg";
import keyLabelDiscount from "../../utils/keyLabelDiscount.json";
import ApplyCouponImg from "../../assets/newPurchase/ApplyCoupon.svg";
import PlusIcon from "../../assets/images/plusIcon.svg"
import CheckTick from "../../assets/images/checked-tick.svg"
import axios from 'axios';

const ApplyCouponDetails = () => {
  const history = useHistory();
  const [couponText, setCouponText] = useState("");
  const [loader, setLoader] = useState(false);
  const [confirmCoupon, setConfirmCoupon] = useState(false);
  const [selectedCouponDetails, setSelectedCouponDetails] = useState({});
  const [appliedCoupon, setAppliedCoupon] = useState({});
  const [genericError, setGenericError] = useState(false);
  const [genericErrorMsg, setGenericErrorMsg] = useState("");
  const { search, state } = useLocation();
  const [toastMsg, setToastMsg] = useState("")
  const [alreadyAppliedError, setAlreadyAppliedError] = useState(false);
  const [noCouponPopup, setNoCouponPopup] = useState(false);
  const [removePopup, setRemovePopup] = useState(false);
  const [redeemed, setRedeemed] = useState(false)
  const isPhoneNumber = new URLSearchParams(search).get("ApplyWithNumber")
  const [autoApplyStatus, setAutoApplyStatus] = useState("") // Stores coupon uuid
  const [showCouponMisMatchPopUp, setShowCouponMisMatchPopUp] = useState(false)
  const [showCouponIsNotValidPopUp, setShowCouponIsNotValidPopUp] = useState(false)
  const couponType = isPhoneNumber ? "USER_BASED" : "ORDER_BASED"
  const [showToggle, setShowToggle] = useState(false)
  const [validCouponList, setValidCouponList] = useState([])
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [uploadHeader, setUploadHeader] = useState('')
  const [uploadSubheader, setUploadSubheader] = useState('')
  const [errorMessage, setErrorMessage] = useState('');
  const MAX_FILE_SIZE_MB = 7;
  const MAX_FILE_SIZE = MAX_FILE_SIZE_MB * 1024 * 1024; // 7 MB in bytes
  const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/png', 'application/pdf'];

  useEffect(() => {
    getExisitingCoupon();
  }, []);

  const getExisitingCoupon = () => {
    let orderId = new URLSearchParams(search).get("orderId");
    console.log('isPhoneNumber:', isPhoneNumber)
    let url = `/api/coupon/getOrderCoupon?orderId=${orderId}`;
    if (isPhoneNumber && state?.number) {
      url = `/api/coupon/getOrderCoupon?phoneNumber=${state?.number}`;
    }
    let config = {
      method: "get",
      url: url,
    };

    setLoader(true);

    makeAPICall(config)
      .then((resp) => {
        console.log(resp, "coupons Applied");
        if (resp && resp.data.status === "SUCCESSFUL") {
          if (resp.data?.data) {
            setAppliedCoupon(resp.data.data.discount_details);
            setRedeemed(resp.data.data.is_redeem);
          } else {
            setAppliedCoupon({});
            setRedeemed(false);
          }
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
      });
  };
  let TARGET_URL = "https://us-central1-pmap-1490493535970.cloudfunctions.net/uploadFileToDrive"
  const handleUpload = async () => {
    if (!file) {
      setErrorMessage('Please select a valid file before uploading.');
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', fileName); // Send custom file name
    console.log("file", file)
    try {
      const response = await axios.post(TARGET_URL, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log('File uploaded successfully:', response.data);
      setFile(null); // Reset file after successful upload
      setFileName(''); // Reset file name after successful upload
    } catch (err) {
      console.error('Error uploading file:', err);
      setErrorMessage('Error uploading file. Please try again.');
    }
  };


  const getCouponStaticData = async () => {
    const response = await (await fetch("api/coupon/getCouponStaticData")).json();
    console.log("responseXXX", JSON.parse(response?.data[0]?.value))
    setValidCouponList(JSON.parse(response?.data[0]?.value)?.coupons_document_proof_required)
    setUploadHeader(JSON.parse(response?.data[0]?.value)?.coupon_document_proof_text)
    setUploadSubheader(JSON.parse(response?.data[0]?.value)?.coupon_document_proof_description)
  }
  useEffect(() => {
    getCouponStaticData()
  }, [])


  const getAutoApplyCouponStatus = (coupon_uuid) => {
    let orderId = new URLSearchParams(search).get("orderId");

    let url = `/api/coupon/getAutoApplyCouponStatus?orderId=${orderId}&couponId=${coupon_uuid}`;
    let config = {
      method: "get",
      url: url,
    };

    setLoader(true);

    makeAPICall(config)
      .then((resp) => {
        console.log(resp, "coupons auto Applied");
        setAutoApplyStatus(resp.data?.data?.is_order_coupon_eligible_for_auto_attach ? coupon_uuid : null)
        setLoader(false);
      })
      .catch((err) => {
        setAutoApplyStatus(false)
        setLoader(false);
      });
  }

  const getAllCoupons = (coupon = "") => {
    if (coupon.length == 0) {
      return;
    }
    let url =
      "/api/coupon/getCoupons" +
      (coupon.length > 0 ? "?title_matches=" + coupon : "");
    let config = {
      method: "get",
      url: url,
    };

    setLoader(true);

    makeAPICall(config)
      .then((resp) => {
        console.log(resp, "allcoupons");
        if (resp && resp.data?.status === "SUCCESSFUL") {
          if (resp.data?.data) {
            if (resp.data.data[0]?.is_active) {
              if (resp.data.data[0]?.coupon_uuid == appliedCoupon?.coupon_uuid) {
                setAlreadyAppliedError(true);
              } else if (resp.data.data?.length == 0) {
                setNoCouponPopup(true);
              } else {
                if (!isPhoneNumber) {
                  getAutoApplyCouponStatus(resp.data.data[0]?.coupon_uuid);
                }
                if (couponType === "ORDER_BASED" && (resp.data.data[0]?.coupon_type === couponType || resp.data.data[0]?.coupon_type === "" || resp.data.data[0]?.coupon_type === null)) {
                  checkCouponPopup(resp.data.data[0]);
                }
                else if (resp.data.data[0]?.coupon_type == couponType) {
                  checkCouponPopup(resp.data.data[0]);
                } else {
                  setShowCouponMisMatchPopUp(true)
                }
              }
            } else {
              setNoCouponPopup(true);
            }
          } else {
            checkCouponPopup({});
          }
        }
        setLoader(false);
      })
      .catch((err) => {
        setLoader(false);
        setGenericErrorMsg("Couldn't get Coupons");
      });
  };
  const couponTextChange = (e) => {
    if (e?.target?.value) {
      setCouponText(e.target.value);
    } else {
      setCouponText("");
      // setCouponsList([]);
    }
  };

  const checkCouponPopup = (selectedCoupon) => {
    console.log("open popup", selectedCoupon);
    setSelectedCouponDetails(selectedCoupon);
    setConfirmCoupon(true);
  };

  const toggleToaster = (msg, time = 2000) => {
    setFile('')
    setFileName('')
    setShowToggle(true)
    setToastMsg(msg)
    setTimeout(() => {
      setShowToggle(false)
      setToastMsg("")
    }, time)
  }
  const clearSearch = () => {
    console.log("insideclear");
    if (couponText.length) {
      couponTextChange();
    }
  };


  const onFileChange = async (evt) => {
    let allowedExtensions = /(\.jpg|\.jpeg|\.png|\.heic|\.heif)$/i;
    const [file] = evt.target?.files;
    setFile(file)
    setFileName(state?.order_id || state?.number || 'FILE_UPLOADED')
    let extension = file?.name.substr(file?.name.lastIndexOf("."));
    let size = parseFloat(file?.size / (1024 * 1024)).toFixed(2);
    console.log('size:', size)
    if (allowedExtensions.exec(extension)) {
      console.log('90890asd:', size)
      if (size <= 7) {
        let reader = new FileReader();
        let base64Version = '';
        reader.readAsDataURL(file);
        reader.onload = async function () {
          base64Version = reader.result;

        };
        if (file) {
          if (extension?.toLowerCase() == ".pdf" || extension?.toLowerCase() == ".heic" || extension?.toLowerCase() == ".heif") {
            document.getElementById('preview-img').src = CheckTick
            document.getElementById('preview-img').style.width = "20%"
            document.getElementById('preview-img').style.left = "38%"
          }
          else {
            console.log(file, URL.createObjectURL(file), "tmpUpload")
            // document.getElementById('preview-img').src = URL.createObjectURL(file);
            document.getElementById('preview-img').style.width = "50%"
            document.getElementById('preview-img').style.left = "0"
          }
        }
      } else {
        toggleToaster("Please upload images less than 7 mb")
      }
    }
    else {
      toggleToaster("Please upload images of type(jpeg,jpg,png,heic,heif)")
    }
  }
  const modifyAppliedCoupon = (type) => {
    if (
      selectedCouponDetails?.discount_qty -
      selectedCouponDetails?.redeem_qty -
      selectedCouponDetails?.locked_qty <=
      0
    ) {
      return;
    }
    let orderId = state?.order_id || new URLSearchParams(search).get("orderId");
    let config = {}
    config = {
      method: "put",
      url: `/api/coupon/modifyCoupon?couponId=${type == "REMOVE"
        ? appliedCoupon.coupon_uuid
        : selectedCouponDetails.coupon_uuid
        }&orderId=${orderId}&removeCoupon=${type === "REMOVE" ? true : false}`,
    };

    if (isPhoneNumber) {
      config = {
        method: "put",
        url: `/api/coupon/modifyCoupon?couponId=${type == "REMOVE"
          ? appliedCoupon.coupon_uuid
          : selectedCouponDetails.coupon_uuid
          }&phoneNumber=${state?.number}&removeCoupon=${type === "REMOVE" ? true : false}`,
      };
    }
    setLoader(true);
    makeAPICall(config)
      .then((resp) => {
        console.log(resp, "coupons updated");
        setConfirmCoupon(false);
        if (resp && resp.data?.status === "SUCCESSFUL") {
          getExisitingCoupon();
          setCouponText("");
        }
        if (resp.data?.data?.status == false) {
          setGenericErrorMsg(resp.data?.data?.message);
          setGenericError(true);
        }
        setLoader(false);
      })
      .catch((err) => {
        console.log("catching", err);
        setLoader(false);
        setGenericErrorMsg(
          "Could not modify the Order for the selected coupon"
        );
        setConfirmCoupon(false);
        setSelectedCouponDetails({});
        setShowCouponIsNotValidPopUp(true);
      });
  };

  let bcUserDetails = JSON.parse(localStorage.getItem("bcUserDetails") || "{}");
  return (
    <div
      className="loan-container"
      style={{ backgroundColor: "white", boxShadow: "none" }}
    >
      {loader && (
        <div
          className="loader"
          onClick={(e) => {
            e.preventDefault();
          }}
        ></div>
      )}
      <div className="header" style={{ boxShadow: "none" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            boxShadow: "none",
          }}
        >
          <Link to="/booking-list">
            <BackArrow removeClass={true} />
          </Link>
        </div>
      </div>
      <div className="main-cont">
        <img src={ApplyCouponImg} alt="applyCoupon" width="54px" />
        <div className="header-text" style={{ marginLeft: "0px" }}>
          {state?.name}
        </div>
        <div className="coupon-order">{state?.order_id || state?.number}</div>
        {appliedCoupon?.coupon_uuid && (
          <div className="appliedCoupon popupCouponDetails">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <img src={GreenTick} />
                <span className="appliedText" style={{ fontSize: "16px" }}>
                  Coupon {redeemed ? "Redeemed" : "Applied"}
                </span>
              </div>
              {!redeemed && <img
                src={CrossIcon}
                alt=""
                width="14px"
                onClick={() => setRemovePopup(true)}
              />}
            </div>
            {appliedCoupon?.discount_qty - appliedCoupon?.locked_qty - appliedCoupon?.redeem_qty <= 0 && <div className="appliedText" style={{ color: '#C91A3A' }}>Coupon exhausted</div>}
            {!appliedCoupon.is_active && <div className="appliedText" style={{ color: '#C91A3A' }}>Coupon deactivated</div>}
            <div>
              {appliedCoupon?.discount_value &&
                JSON.parse(appliedCoupon?.discount_value).map((discItem) => (
                  <div className="user-name">
                    {discItem.type === "FLAT_REDUCTION" ||
                      discItem.type === "FLAT_REPLACE"
                      ? `Flat ${discItem.value} off on ${keyLabelDiscount.find(
                        (a) => a.key == discItem.componentId
                      )?.label || discItem.componentId
                      }`
                      : discItem.type === "PERCENT_REDUCTION"
                        ? `${discItem.value}% off on ${keyLabelDiscount.find(
                          (a) => a.key == discItem.componentId
                        )?.label || discItem.componentId
                        }`
                        : ""}
                    {appliedCoupon?.coupon_uuid == autoApplyStatus && <span style={{ color: "#16AA51" }}> • Auto attached as price is ₹0</span>}
                  </div>
                ))}
            </div>
            {!redeemed && <div>Expires on {appliedCoupon?.end_date.slice(0, 10)}</div>}
          </div>
        )}
        <hr style={{ width: "90%", opacity: "0.4" }} />
        <div className="inner-container" style={{ width: "100%" }}>
          <div className="form-container">
            <div
              className="loan-inputfield"
              style={{ width: "100%", display: "flex" }}
            >
              <FloatingInput
                id="orderId"
                name="orderId"
                type="text"
                labelName="Search coupon code"
                inputValue={couponText}
                onChange={couponTextChange}
                className={`card-number flex1`}
                placeholder="Search coupon code"
                maxLength={25}
              />
              {couponText.length > 0 && (
                <img
                  src={CrossIcon}
                  alt=""
                  className="CrossImg"
                  onClick={clearSearch}
                />
              )}
            </div>
          </div>
          {appliedCoupon?.coupon_uuid && !redeemed ? (
            <div className="two-btns">
              <button
                className="cancel"
                onClick={() => {
                  getAllCoupons(couponText);
                }}
              >
                Replace
              </button>
            </div>
          ) : (
            <div className="two-btns">
              <button
                className="confirm"
                onClick={() => {
                  getAllCoupons(couponText);
                }}
              >
                Add
              </button>
            </div>
          )}
          {/* <div>
            {couponsList.map((coupon) => (
              <>
                <div
                  className="orderlist-container"
                  onClick={() => checkCouponPopup(coupon)}
                  style={{ height: "auto" }}
                >
                  <div>
                    <div className="order-number">
                      {coupon.title}{" "}
                      {appliedCoupon?.coupon_uuid === coupon?.coupon_uuid && (
                        <span className="appliedText">
                          {" "}
                          • <img src={GreenTick} /> Applied
                        </span>
                      )}
                    </div>
                    <div className="user-name">{coupon.description}</div>
                    {JSON.parse(coupon?.discount_value).map((discItem) => (
                      <div className="user-name">
                        {discItem.type === "FLAT_REDUCTION" ||
                        discItem.type === "FLAT_REPLACE"
                          ? `Flat ${discItem.value} off on ${
                              keyLabelDiscount.find(
                                (a) => a.key == discItem.componentId
                              )?.label
                            }`
                          : discItem.type === "PERCENT_REDUCTION"
                          ? `${discItem.value}% off on ${
                              keyLabelDiscount.find(
                                (a) => a.key == discItem.componentId
                              )?.label
                            }`
                          : ""}
                      </div>
                    ))}
                    <div className="user-name">
                      {coupon.discount_qty -
                        coupon?.redeem_qty -
                        coupon?.locked_qty >
                      0
                        ? coupon.discount_qty -
                          coupon?.redeem_qty -
                          coupon?.locked_qty
                        : 0}{" "}
                      Coupons • Expires on {coupon.end_date.slice(0, 10)}
                    </div>
                  </div>
                  <img
                    src={rightArrow}
                    alt="rightArrow"
                    style={{ height: 30, width: 30 }}
                  />
                </div>
                <hr style={{ opacity: "0.5", margin: "8px 14px" }} />
              </>
            ))}
          </div> */}
        </div>
      </div>

      {showCouponMisMatchPopUp &&
        <GenericModal onClose={() => setShowCouponMisMatchPopUp(false)} showClose={false}>
          <div className="wrong-coupon-popup">
            <div className="wrong-coupon-title-section">
              <div className="error-heading">Wrong Coupon </div>
              <div><img src={WarnRed} alt="green-tag" className="warn-icon" /></div>
            </div>
            <div className="couponTitle">{`This coupon can be applied on ${couponType == "USER_BASED" ? "order id" : "mobile number"} only.`}</div>
            <div className="two-btns">
              <button
                className="confirm"
                onClick={() => {
                  setShowCouponMisMatchPopUp(false)
                }}
              >
                Okay
              </button>
            </div>
          </div>

        </GenericModal>}

      {confirmCoupon && (
        <GenericModal
          onClose={() => {
            setConfirmCoupon(false);
            setSelectedCouponDetails({});
          }}
          showClose={false}
        >
          <div className={`tr-validation-container ${"trCont"}`}>
            <div className="heading-container">
              <p className="error-heading">
                {appliedCoupon?.coupon_uuid
                  ? "Replace coupon"
                  : "Confirm Coupon"}
              </p>
              <img src={Coupon} alt="green-tag" className="warn-icon" />
            </div>
            <div className="error-subheading">
              <div>{state?.name}</div>
              <div>{state?.order_id}</div>
            </div>
            <div className="popupCouponDetails">
              <div className="couponTitle">
                {selectedCouponDetails?.title}
                {selectedCouponDetails?.coupon_uuid ===
                  appliedCoupon?.coupon_uuid && (
                    <span className="appliedText">
                      {" "}
                      • <img src={GreenTick} /> Applied
                    </span>
                  )}
              </div>
              <div className="description">
                {selectedCouponDetails?.description}
              </div>
              {JSON.parse(selectedCouponDetails?.discount_value).map(
                (discItem) => (
                  <div className="description">
                    {discItem.type === "FLAT_REDUCTION" ||
                      discItem.type === "FLAT_REPLACE"
                      ? `Flat ${discItem.value} off on ${keyLabelDiscount.find(
                        (a) => a.key == discItem.componentId
                      )?.label || discItem.componentId
                      }`
                      : discItem.type === "PERCENT_REDUCTION"
                        ? `${discItem.value}% off on ${keyLabelDiscount.find(
                          (a) => a.key == discItem.componentId
                        )?.label || discItem.componentId
                        }`
                        : ""}
                    {selectedCouponDetails?.coupon_uuid == autoApplyStatus && <span style={{ color: "#16AA51" }}> • Auto attached as price is ₹0</span>}
                  </div>
                )
              )}
              <div className="description">
                <span
                  style={{
                    color:
                      selectedCouponDetails?.discount_qty -
                        selectedCouponDetails?.redeem_qty -
                        selectedCouponDetails?.locked_qty >
                        0
                        ? "rgba(0, 0, 0, 0.56)"
                        : "#C91A3A",
                  }}
                >
                  {selectedCouponDetails?.discount_qty -
                    selectedCouponDetails?.redeem_qty -
                    selectedCouponDetails?.locked_qty >
                    0
                    ? selectedCouponDetails?.discount_qty -
                    selectedCouponDetails?.redeem_qty -
                    selectedCouponDetails?.locked_qty
                    : 0}
                </span>{" "}
                Coupons {!redeemed && `• Expires on ${selectedCouponDetails?.end_date.slice(0, 10)}`}
              </div>
            </div>

            {/* upload documents */}
            {
              validCouponList.includes(selectedCouponDetails?.title) &&
              <>
                <div className="uploadTitle">{uploadHeader}</div>
                <div className="uploadTitle2">{uploadSubheader}</div>
                <div className="uploadImgWrapper">
                  <div className="uploadImage">
                    {!file ? <img className="plus-icon" src={PlusIcon} alt="" /> :
                      <img
                        src={URL.createObjectURL(file)} style={{ width: '100%', height: '160px' }}>
                      </img>
                    }
                    <input
                      className="input-file"
                      id='uploadInput'
                      type="file"
                      data
                      onInput={(evt) => onFileChange(evt)}
                      onClick={(event) => { if (!(file)) { event.target.value = null } }}
                    />
                  </div>

                  <div
                    style={{ display: file ? 'block' : 'none' }}
                    className="upload-preview-img"
                  >
                    <img className="previewImg" id="preview-img" src="#" alt="" />
                  </div>
                </div>
              </>
            }
            {showToggle && <div className="toaster">{toastMsg}</div>}
            {appliedCoupon?.coupon_uuid &&
              selectedCouponDetails?.discount_qty -
              selectedCouponDetails?.redeem_qty -
              selectedCouponDetails?.locked_qty >
              0 && (
                <div className="error-subheading" style={{ width: "100%" }}>
                  <div>The new coupon will replace the existing coupon</div>
                </div>
              )}
            {selectedCouponDetails?.discount_qty -
              selectedCouponDetails?.redeem_qty -
              selectedCouponDetails?.locked_qty <=
              0 && (
                <div className="error-subheading" style={{ width: "100%" }}>
                  <div>
                    This coupon might get available. Please try again after
                    sometime
                  </div>
                </div>
              )}
            <div className="two-btns">
              <button
                className="cancel"
                onClick={() => {
                  setFile('')
                  setFileName('')
                  setConfirmCoupon(false);
                  setSelectedCouponDetails({});
                }}
              >
                {appliedCoupon?.coupon_uuid ===
                  selectedCouponDetails?.coupon_uuid
                  ? "Dismiss"
                  : "Cancel"}
              </button>
              <button
                className="confirm"
                onClick={() => {
                  modifyAppliedCoupon("APPLY");
                  validCouponList?.includes(selectedCouponDetails?.title) && handleUpload()
                }}
                {...(validCouponList?.includes(selectedCouponDetails?.title) ? { disabled: !file ? true : false } : {})}
                style={validCouponList?.includes(selectedCouponDetails?.title) ? {
                  background:
                    (selectedCouponDetails?.discount_qty -
                      selectedCouponDetails?.redeem_qty -
                      selectedCouponDetails?.locked_qty >
                      0) && file
                      ? "#000000"
                      : "rgba(0, 0, 0, 0.36)",
                } : {
                  background:
                    (selectedCouponDetails?.discount_qty -
                      selectedCouponDetails?.redeem_qty -
                      selectedCouponDetails?.locked_qty >
                      0)
                      ? "#000000"
                      : "rgba(0, 0, 0, 0.36)",
                }}
              >
                {(appliedCoupon?.coupon_uuid && !redeemed) ? "Replace" : "Apply"}
              </button>
            </div>
          </div>
        </GenericModal>
      )}
      {genericError && (
        <GenericModal onClose={() => setGenericError(false)} showClose={false}>
          <div className={`tr-validation-container ${"trCont"}`}>
            <div className="heading-container">
              <p className="error-heading">Something Went Wrong</p>
              <img src={WarnRed} alt="warning" className="warn-icon" />
            </div>
            <div className="error-subheading">
              <div>{genericErrorMsg}</div>
            </div>
            <div className="two-btns">
              <button
                className="cancel"
                onClick={() => {
                  setGenericError(false);
                }}
              >
                Okay
              </button>
            </div>
          </div>
        </GenericModal>
      )}
      {alreadyAppliedError && (
        <GenericModal
          onClose={() => setAlreadyAppliedError(false)}
          showClose={false}
        >
          <div className={`tr-validation-container ${"trCont"}`}>
            <div className="heading-container">
              <p className="error-heading">Coupon already applied</p>
              <img src={WarnRed} alt="warning" className="warn-icon" />
            </div>
            <div className="error-subheading">
              <div>You cannot apply this coupon twice on the same order id</div>
            </div>
            <div className="two-btns">
              <button
                className="confirm"
                onClick={() => {
                  setAlreadyAppliedError(false);
                }}
              >
                Got it
              </button>
            </div>
          </div>
        </GenericModal>
      )}
      {noCouponPopup && (
        <GenericModal onClose={() => setNoCouponPopup(false)} showClose={false}>
          <div className={`tr-validation-container ${"trCont"}`}>
            <div className="heading-container">
              <p className="error-heading">Coupon not found</p>
              <img src={WarnRed} alt="warning" className="warn-icon" />
            </div>
            <div className="error-subheading">
              <div>kindly check for any spelling mistakes and try again</div>
            </div>
            <div className="two-btns">
              <button
                className="confirm"
                onClick={() => {
                  setNoCouponPopup(false);
                }}
              >
                Got it
              </button>
            </div>
          </div>
        </GenericModal>
      )}
      {showCouponIsNotValidPopUp && (
        <GenericModal onClose={() => setShowCouponIsNotValidPopUp(false)} showClose={false}>
          <div className={`tr-validation-container ${"trCont"}`}>
            <div className="heading-container">
              <p className="error-heading">Coupon is not valid</p>
              <img src={WarnRed} alt="warning" className="warn-icon" />
            </div>
            <div className="error-subheading">
              <div>Coupon is not valid for the Order Id / Phone number</div>
            </div>
            <div className="two-btns">
              <button
                className="confirm"
                onClick={() => {
                  setShowCouponIsNotValidPopUp(false);
                }}
              >
                Got it
              </button>
            </div>
          </div>
        </GenericModal>
      )}
      {removePopup && (
        <GenericModal onClose={() => setRemovePopup(false)} showClose={false}>
          <div className={`tr-validation-container ${"trCont"}`}>
            <div className="heading-container">
              <p className="error-heading">Are you sure want remove coupon</p>
              <img src={WarnRed} alt="warning" className="warn-icon" />
            </div>
            {/* <div className="error-subheading">
              <div>kindly check for any spelling mistakes and try again</div>
            </div> */}
            <div className="two-btns">
              <button
                className="cancel"
                onClick={() => {
                  setRemovePopup(false);
                }}
              >
                Cancel
              </button>
              <button
                className="confirm"
                onClick={() => {
                  modifyAppliedCoupon("REMOVE");
                  setRemovePopup(false);
                  setFile('')
                  setFileName('')
                }}
              >
                Remove
              </button>
            </div>
          </div>
        </GenericModal>
      )}
    </div>
  );
};

export default ApplyCouponDetails;
